import * as Sentry from '@sentry/react'

export type PrSummaryEvent = {
  type:
    | 'pr_summary_eval_status'
    | 'pr_summary_eval_progress'
    | 'pr_summary_eval_current'
    | 'pr_summary_stream'
    | 'ping'
    | 'error'
  status?: string
  total?: number
  completed?: number
  failed?: number
  sync_counts?: { new: number; changed: number; unchanged: number; closed: number }
  repo?: string
  pr_number?: number
  pr_title?: string
  content?: string
  tool_name?: string
  tool_input?: string
  tool_result?: string
  error?: string
}

export function createPrSummarySocket(
  onEvent: (event: PrSummaryEvent) => void,
  onClose?: () => void,
) {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const ws = new WebSocket(`${protocol}//${window.location.host}/api/pr-summary/ws`)

  ws.onmessage = (e) => {
    try {
      const event: PrSummaryEvent = JSON.parse(e.data)
      if (event.type === 'ping') return
      if (event.type === 'error') {
        Sentry.captureMessage(`PR Summary error: ${event.error ?? 'Unknown'}`, 'error')
      }
      onEvent(event)
    } catch {
      console.error('Failed to parse pr-summary event:', e.data)
    }
  }

  ws.onclose = () => onClose?.()

  const close = () => ws.close()

  return { close, ws }
}
